
import { useCallback } from 'react';

export const useCoordinatePaste = <T>(
  setFormData: React.Dispatch<React.SetStateAction<T>>,
  setFormErrors?: React.Dispatch<React.SetStateAction<Record<string, string>>>,
  latField: keyof T = 'lat' as keyof T,
  lonField: keyof T = 'lon' as keyof T
) => {
  const handlePasteCoordinates = useCallback((event: React.ClipboardEvent<HTMLDivElement>) => {
    const pastedData = event.clipboardData.getData('text');
    
    // Check if the pasted text contains a comma
    if (pastedData?.includes(',')) {
      event.preventDefault();
      const parts = pastedData.split(',').map(part => part.trim());
      
      // We expect at least two parts: lat and lon
      if (parts.length >= 2) {
        const lat = Number.parseFloat(parts[0]);
        const lon = Number.parseFloat(parts[1]);

        // Check if both are valid numbers
        if (!Number.isNaN(lat) && !Number.isNaN(lon)) {
          setFormData((prev) => ({
            ...prev,
            [latField]: lat,
            [lonField]: lon
          }));
          
          // Clear errors for lat/lon if they exist
          if (setFormErrors) {
            setFormErrors((prev) => {
              const newErrors = { ...prev };
              delete newErrors[latField as string];
              delete newErrors[lonField as string];
              return newErrors;
            });
          }
        }
      }
    }
  }, [setFormData, setFormErrors, latField, lonField]);

  return handlePasteCoordinates;
};
